
let branchItem
let branchParent

export function getBranchItemByBookmarkPresentationID(bookmarkPresentationID) {

    getBranchItem(window.tree, bookmarkPresentationID)

    return branchItem
}

export function getBranchItemByPresentationID(PresentationID) {

    getBranchItemByPresentationIDRecursive(window.tree, PresentationID)

    return branchItem
}

function getBranchItem(branch, bookmarkPresentationID) {

    if(branch.branch) {
        branchParent = branch
        branch = branch.branch
    }
    branch.map( branchChild => {
        if( (!branchChild.folder || branchChild.Type === 2) && parseInt(branchChild.ID) === parseInt(bookmarkPresentationID)) {

            branchItem = branchChild

            if(branchChild.label === branchParent.label) {
                branchItem.parent = branchParent
            }
        }
        if(branchChild.branch) {
            getBranchItem(branchChild, bookmarkPresentationID)
        }
    })
}

function getBranchItemByPresentationIDRecursive(branch, bookmarkPresentationID) {

    if(branch.branch) {
        branchParent = branch
        branch = branch.branch
    }
    branch.map( branchChild => {
        if( (!branchChild.folder || branchChild.Type === 2) && parseInt(branchChild.PresentationID) === parseInt(bookmarkPresentationID)) {
            branchItem = branchChild
            branchItem.parent = branchParent
        }
        if(branchChild.branch) {
            getBranchItem(branchChild, bookmarkPresentationID)
        }
    })
}
